/* tslint:disable */
/* eslint-disable */
/**
 * crm-screener-api
 * crm-screener-api
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import type { FindAllScreenerTags200ResponseDataInner } from './FindAllScreenerTags200ResponseDataInner';
import {
    FindAllScreenerTags200ResponseDataInnerFromJSON,
    FindAllScreenerTags200ResponseDataInnerFromJSONTyped,
    FindAllScreenerTags200ResponseDataInnerToJSON,
} from './FindAllScreenerTags200ResponseDataInner';

/**
 * 
 * @export
 * @interface FindAllScreenerTags200Response
 */
export interface FindAllScreenerTags200Response {
    /**
     * 
     * @type {Array<FindAllScreenerTags200ResponseDataInner>}
     * @memberof FindAllScreenerTags200Response
     */
    data?: Array<FindAllScreenerTags200ResponseDataInner>;
}

/**
 * Check if a given object implements the FindAllScreenerTags200Response interface.
 */
export function instanceOfFindAllScreenerTags200Response(value: object): boolean {
    let isInstance = true;

    return isInstance;
}

export function FindAllScreenerTags200ResponseFromJSON(json: any): FindAllScreenerTags200Response {
    return FindAllScreenerTags200ResponseFromJSONTyped(json, false);
}

export function FindAllScreenerTags200ResponseFromJSONTyped(json: any, ignoreDiscriminator: boolean): FindAllScreenerTags200Response {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'data': !exists(json, 'data') ? undefined : ((json['data'] as Array<any>).map(FindAllScreenerTags200ResponseDataInnerFromJSON)),
    };
}

export function FindAllScreenerTags200ResponseToJSON(value?: FindAllScreenerTags200Response | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'data': value.data === undefined ? undefined : ((value.data as Array<any>).map(FindAllScreenerTags200ResponseDataInnerToJSON)),
    };
}

